import gql from 'graphql-tag';


export const QUERY_GET_PICKING_AUDIT = gql`query getPickingInfoBy($id: String!) {
  getPickingInfoBy(orderId: $id) {
    results {
      ... on PickingProcess {
        pickingTime {
          stats {
              init
              end
              correlative
              field
          }
        }

        orderWithLoader {
          id
          isWhatsapp
          windowAnticipated
          shippingChange
          items {
            id
            ean
            name
            imageUrl
            sku
            isUnit
            brandName
            listPrice
            split
            splitStatus
            quantity
            sellingPrice
            basePrice
            customerNotes
            refId
            unitMultiplier
            isGiftCencosud
            substitution {
              label
              code
            }
            priceTags {
              value
              rateAndBenefit {
                name
              }
            }
            unit
            isUpselling
          }
        }

        split
        emailSpliter
        nameSpliter
        eanSplitList

        removedItems {
          productId
          id
          sku
          status
          imageUrl
          refId
          ean
          price
          name
          brandName
          pickingQuantity
          unitMultiplier
          invoicePrice
          sellingPrice
          unit
          excess
        }
        weightError
        semaphore
        items {
          audits {
            decision
            codeRule
            smartrules {
              reason
              subReasons
            }
          }
          split
          splitStatus
          splitQuantity
          productId
          manualPicking
          id
          refId
          sku
          ean
          unpackaged
          price
          name
          brandName
          imageUrl
          status
          statusCode
          pickingQuantity
          unitMultiplier
          invoicePrice
          sellingPrice
          unit
          excess
          substitution {
            brandName
            sku
            manualPicking
            unpackaged
            ean
            price
            name
            imageUrl
            status
            unitMultiplier
            pickingQuantity
            invoicePrice
            sellingPrice
            excess
            unit
            refId
          }
        }

        auditInfo {
          failedCount
          passedCount
          rules
          results {
            failed {
              productId
              failed
              rules
              audits {
                codeRule
                decision
                value
                smartrules {
                  reason
                  subReasons
                }
              }
            }
          }
        }

      }
    }
  }
}
`;
